import { ref, reactive } from 'vue';
import moment from 'moment';

const initialState = () => {
    return {
        notifications: reactive([]),
        sessionReminderLastShownAt: ref(null),
        datePickerOpen: ref(false),
        paymentFormOpen: ref(false),
    };
};

const state = initialState();

state.isDark = ref(true);

const actions = {
    resetGlobalState({ commit }) {
        commit('resetState');
    },
};

const mutations = {
    updateNotifications(state, notifications) {
        Object.assign(state.notifications, notifications);
    },

    updateNotification(state, notification) {
        state.notifications.filter((item, key) => {
            if (item.id === notification.id) {
                state.notifications.splice(key, 1);
            }
        });
    },

    setDarkModeIfUndefined(state) {
        if (state.isDark === undefined) {
            state.isDark = true;
        }
    },

    setSessionReminderLastShownAt(state) {
        state.sessionReminderLastShownAt = moment();
    },

    toggleDarkMode(state) {
        state.isDark = !state.isDark;
    },

    toggleDatePicker(state, value) {
        state.datePickerOpen = value;
    },

    togglePaymentForm(state, value) {
        state.paymentFormOpen = value;
    },

    resetState(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    sessionReminderLastShownAt(state) {
        return state.sessionReminderLastShownAt;
    },

    notifications(state) {
        return state.notifications;
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
